import { render, staticRenderFns } from "./ParentSubjectUploads.vue?vue&type=template&id=18e87e44&"
import script from "./ParentSubjectUploads.vue?vue&type=script&lang=js&"
export * from "./ParentSubjectUploads.vue?vue&type=script&lang=js&"
import style0 from "./ParentSubjectUploads.vue?vue&type=style&index=0&id=18e87e44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports